import React, { useState, useEffect } from 'react'
import { Table, Panel } from 'rsuite'
import { Icon, IconButton, ButtonGroup, Modal, Button, Input, InputGroup } from 'rsuite'
import { budgetFormat, numberThousandSeparator } from '../../../utils/formatterUtil'

export default function BudgetTableForm({
  schema,
  handleDelete = () => {},
  handleEdit = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const [dataList, setDataList] = useState([])

  const [isdelete, setIsdelete] = useState(false)
  // const [deleteIndex, setDeleteIndex] = useState()
  const [deleteId, setDeleteId] = useState()
  const [isResizable, setIsResizable] = useState(false)
  const [isSearch, setIsSearch] = useState(false)

  const [sortColumn, setSortColumn] = useState()
  const [sortType, setSortType] = useState()
  const [loading, setLoading] = useState(false)

  const [dataTable, setDataTable] = useState()
  const [inputSearchValue, setInputSearchValue] = useState('')
  const [inputSearchPlaceholder, setInputSearchPlaceholder] = useState('')

  useEffect(() => {
    switch (schema.categoryType) {
      case 1:
        setInputSearchPlaceholder('ค้นหากิจกรรม/ค่าดำเนินโครงการ/รายละเอียดค่าใช้จ่าย')
        break

      case 2:
        setInputSearchPlaceholder('ค้นหาค่าบริหารโครงการ/รายละเอียดค่าใช้จ่าย')
        break

      case 3:
        setInputSearchPlaceholder('ค้นหาครุภัณฑ์โครงการ/รายละเอียดค่าใช้จ่าย')
        break

      default:
        break
    }
  }, [schema])

  useEffect(() => {
    if (schema.categoryType && schema.categoryType < 4) {
      setIsResizable(true)
      setIsSearch(true)
    }
    if (schema.name === 'activityBudget') {
      let dataArr = [...schema.values]
      if (dataArr.length > 0) {
        let sumPrice = 0
        dataArr.forEach((item) => {
          sumPrice += parseFloat(item.sumPrice)
        })

        let summarryObj = {
          stongText: 'จำนวนเงินรวม',
          sumPrice: sumPrice,
        }

        dataArr.push(summarryObj)
      }
      // console.log('dataArr ', dataArr)
      setDataList(dataArr)
    }
    setDataTable(schema?.values)
    setInputSearchValue('')
  }, [schema])

  const getData = () => {
    if (sortColumn && sortType) {
      return dataTable.sort((a, b) => {
        let x = a[sortColumn]
        let y = b[sortColumn]
        if (typeof x === 'string') {
          x = x.charCodeAt()
        }
        if (typeof y === 'string') {
          y = y.charCodeAt()
        }
        if (sortType === 'asc') {
          return x - y
        } else {
          return y - x
        }
      })
    }
    return dataTable
  }

  const handleSortColumn = (sortColumn, sortType) => {
    setLoading(true)
    setTimeout(() => {
      setLoading(false)
      setSortColumn(sortColumn)
      setSortType(sortType)
    }, 500)
  }

  const handleSearchDataTable = (type) => {
    let result = []
    if (inputSearchValue) {
      schema?.values?.map((item) => {
        console.log(type, 'item ', item)
        switch (type) {
          case 1:
            if (
              item.activityName.match(inputSearchValue) ||
              item.costName.match(inputSearchValue) ||
              item.costDetail.match(inputSearchValue)
            ) {
              result.push(item)
            }
            break

          case 2:
            if (
              item.costName.match(inputSearchValue) ||
              item.subCostName.match(inputSearchValue) ||
              item.costDetail.match(inputSearchValue)
            ) {
              result.push(item)
            }
            break

          case 3:
            if (
              item.costName.match(inputSearchValue) ||
              item.costDetail.match(inputSearchValue) ||
              item.costDate.match(inputSearchValue)
            ) {
              result.push(item)
            }
            break

          default:
            break
        }
      })

      setDataTable(result)
    } else {
      setDataTable(schema?.values)
    }
  }

  const handleChangeVal = (val) => {
    setInputSearchValue(val)
  }

  return (
    <>
      {isSearch && (
        // <div style={{ textAlign: '-webkit-right', marginTop: -46 }}>
        <div style={{ marginBottom: 10 }}>
          <hr />
          <InputGroup inside style={{ width: '100%' }}>
            <Input
              value={inputSearchValue}
              style={{ borderColor: '#2da888' }}
              onChange={handleChangeVal}
              placeholder={inputSearchPlaceholder}
            />
            <InputGroup.Button
              style={{ backgroundColor: '#2da888', color: '#ffffff' }}
              onClick={() => {
                handleSearchDataTable(schema?.categoryType)
              }}
            >
              <Icon icon="search" />
            </InputGroup.Button>
          </InputGroup>
        </div>
        // </div>
      )}

      <Panel eventKey={2} bodyFill>
        <div>
          <Table
            rowKey="id"
            height={dataList?.length >= 10 && schema.categoryType == 1 ? 800 : 400}
            autoHeight={dataTable?.length <= 5}
            wordWrap={true}
            // data={schema.name === 'activityBudget' ? dataList : schema.values}
            //data={schema.values}
            data={getData()}
            sortColumn={sortColumn}
            sortType={sortType}
            onSortColumn={handleSortColumn}
            loading={loading}
          >
            {schema.costName && schema.name != 'activityBudget' && (
              <Column sortable resizable={isResizable} width={250}>
                <HeaderCell>{schema.costName.label}</HeaderCell>
                {/* <Cell dataKey={schema.costName.name} /> */}
                <Cell dataKey="costName">
                  {(rowData) => {
                    let str = ''
                    if (rowData.costName === 'ค่าบริหารจัดการสำนักงาน') {
                      str = `${rowData.costName} - ${rowData.subCostName}`
                    } else {
                      str = rowData.costName
                    }
                    return str
                  }}
                </Cell>
              </Column>
            )}

            {schema.name === 'activityBudget' && (
              <Column sortable resizable={isResizable} width={250}>
                <HeaderCell>กิจกรรม</HeaderCell>
                <Cell dataKey={'activityName'} />
              </Column>
            )}

            {schema.acCostOption && (
              <Column resizable={isResizable} width={250}>
                <HeaderCell>{schema.acCostOption.label}</HeaderCell>
                <Cell dataKey="costName" />
                {/* <Cell>
                {(rowData) => {
                  return getValueFromOptions(schema.acCostOption.options, rowData.id)
                }}
              </Cell> */}
              </Column>
            )}

            {schema.costDetail && (
              <Column sortable resizable={isResizable} minWidth={270} width={270}>
                <HeaderCell>{schema.costDetail.label}</HeaderCell>
                <Cell dataKey={schema.costDetail.name} />
              </Column>
            )}

            {schema.costTime && (
              <Column resizable={isResizable} width={180} align="center">
                <HeaderCell>วันที่เริ่มใช้ครุภัณฑ์</HeaderCell>
                <Cell dataKey="costDate" />
              </Column>
            )}

            {schema.costPerUnit && (
              <Column resizable={isResizable} width={150} align="right">
                <HeaderCell>{schema.costPerUnit.label}</HeaderCell>
                {/* <Cell dataKey={schema.costPerUnit.name} /> */}
                <Cell dataKey="costPerUnit">
                  {(rowData) => {
                    return budgetFormat(rowData.costPerUnit)
                  }}
                </Cell>
              </Column>
            )}

            {schema.costPerVat && (
              <Column resizable={isResizable} width={140} align="right">
                <HeaderCell>{schema.costPerVat.label}</HeaderCell>
                {/* <Cell dataKey={schema.costPerVat.name}></Cell> */}
                <Cell dataKey={schema.costPerVat.name}>
                  {(rowData) => {
                    return numberThousandSeparator(rowData[schema.costPerVat.name])
                  }}
                </Cell>
              </Column>
            )}

            {schema.quantity && (
              <Column resizable={isResizable} width={120} align="right">
                <HeaderCell>{schema.quantity.label || 'จำนวน'}</HeaderCell>
                {/* <Cell dataKey={schema.quantity.name} /> */}
                <Cell dataKey="quantity">
                  {(rowData) => {
                    return budgetFormat(rowData.quantity)
                  }}
                </Cell>
              </Column>
            )}

            {schema.unitOfMeasure && schema.unitOfMeasure != '' && (
              <Column resizable={isResizable} width={120}>
                <HeaderCell>{schema.unitOfMeasure.label}</HeaderCell>
                <Cell dataKey={schema.unitOfMeasure.name} />
              </Column>
            )}

            <Column resizable={isResizable} width={180} align="right">
              <HeaderCell>จำนวนเงิน (บาท)</HeaderCell>
              <Cell dataKey="sumPrice">
                {(rowData) => {
                  return budgetFormat(rowData.sumPrice)
                }}
              </Cell>
            </Column>

            <Column resizable={isResizable} width={200} align="center" fixed="right">
              <HeaderCell></HeaderCell>

              <Cell>
                {(rowData, index) => {
                  return (
                    <ButtonGroup>
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-edit"
                        icon={<Icon icon="edit" className="bt-gost-icon-radius-edit" />}
                        onClick={(e) => {
                          handleEdit(rowData)
                        }}
                      >
                        แก้ไข
                      </IconButton>
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-cancel"
                        icon={<Icon icon="trash-o" className="bt-gost-icon-none-radius-cancel" />}
                        onClick={(e) => {
                          // handleAndValidateDelete(rowData, index)
                          setIsdelete(true)
                          // setDeleteIndex(index)
                          setDeleteId(rowData.id)
                        }}
                      >
                        ลบ
                      </IconButton>
                    </ButtonGroup>
                  )
                }}
              </Cell>
            </Column>

            {/* {schema.stongText && (
            <Column width={120} align="right">
              <HeaderCell>จำนวนเงิน (บาท)</HeaderCell>
              <Cell>
                {(rowData) => {
                  console.log('xxx ', rowData)
                  return rowData.stongText ? (
                    <span>
                      <b>{budgetFormat(rowData.sumPrice)}</b>
                    </span>
                  ) : (
                    budgetFormat(rowData.sumPrice)
                  )
                }}
              </Cell>
            </Column>
          )} */}
          </Table>
        </div>

        <Modal
          show={isdelete}
          onHide={(e) => {
            setIsdelete(false)
          }}
        >
          <Modal.Header>
            <Modal.Title>ยืนยันการลบ</Modal.Title>
          </Modal.Header>
          <Modal.Body>{'ยืนยันการลบ ' + (schema.buttonText ? schema.buttonText : '')}</Modal.Body>
          <Modal.Footer>
            <Button
              onClick={(e) => {
                // handleDelete(deleteIndex)
                handleDelete(deleteId)
                setIsdelete(false)
              }}
              appearance="primary"
            >
              ลบ
            </Button>
            <Button
              onClick={(e) => {
                setIsdelete(false)
                // setDeleteIndex('')
                setDeleteId('')
              }}
              appearance="subtle"
            >
              ยกเลิก
            </Button>
          </Modal.Footer>
        </Modal>
      </Panel>
    </>
  )
}
